import cmsClient from "src/services/cmsClient";

export interface Options {
	formId: number;
	storeId?: number;
}

export const downloadAllObservations = async ({ formId, storeId }: Options) => {
	// ✅ check storeId at runtime because it can be `undefined`
	if (!storeId) {
		return Promise.reject(new Error("Invalid storeId"));
	}

	const url = "observations/reports/all-observations-by-store-form/";

	const response = await cmsClient.get(url, {
		params: { form_id: formId, store_id: storeId },
		responseType: "blob"
	});

	return response.data;
};

const useAllStoresObservationsReport = ({ formId, storeId }: Options) => {
	const download = async () => {
		try {
			const response = await downloadAllObservations({ formId, storeId });

			const url = window.URL.createObjectURL(new Blob([response]));

			const link = document.createElement("a");
			link.href = url;
			link.setAttribute("download", `all-observations-by-store-${storeId}.csv`);

			document.body.appendChild(link);

			link.click();
		} catch (error) {
			console.error(
				"FAILED TO DOWNLOAD ALL OBSERVATIONS REPORT BY STORE ID",
				error
			);
		}
	};

	return { download };
};

export default useAllStoresObservationsReport;
